import mendeleev from "@/urls/mendeleev"
import {
  sendGetRequest, sendPostRequest
} from "@/helper/requests"

const state = {
  users: {
    info: null,
    currentUrl: null,
    items: [],
    loading: false,
    count: 0,
    detail: [],
    next: null,
    prev: null,
    error: null,
  }
}

const getters = {
  getUsers: state => state.users.items,
  getUserInfo: state => state.users.info,
  getUsersCount: state => state.users.count,
  getUsersCurrentUrl: state => state.users.currentUrl,
  getUsersNext: state => state.users.next,
  getUsersPrev: state => state.users.prev,
  getUsersDetail: state => state.users.detail,
  isLoadingUsers: state => state.users.loading,
  saveUsersError: state => state.users.error,
}

const actions = {
  loadUsers: ({ commit, getters }, { url, urlAppend, finalizer = () => {}, catcher = () => {} }) => {
    if (!url) {
      url = mendeleev.USER.PROFILE.LIST()
      if (urlAppend) url = urlAppend(url)
    }
    if (!getters.isLoadingUsers) {
      commit('SET_USERS_LOADING')
      sendGetRequest(
        url, (data, url) => {
          commit('SET_USERS', data.results)
          commit('SET_USERS_COUNT', data.count)
          commit('SET_USERS_CURRENT_URL', url)
          commit('SET_USERS_NEXT_URL', data.next)
          commit('SET_USERS_LOADING_END')
          finalizer(data, url)
        }, (data, url) => {
          commit('SET_USERS_LOADING_END')
          commit('SAVE_USERS_ERROR', data)
          catcher(data, url)
        }
      )
    }
  },
  loadUserInfo: ({ commit, getters }, { finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.PROFILE.INFO()
    if (!getters.isLoadingUsers) {
      commit('SET_USERS_LOADING')
      sendGetRequest(
        url, (data, url) => {
          commit('SET_USER_INFO', data)
          commit('SET_USERS_LOADING_END')
          finalizer(data, url)
        }, (data, url) => {
          commit('SET_USERS_LOADING_END')
          commit('SAVE_USERS_ERROR', data)
          catcher(data, url)
        }
      )
    }
  },
  createUser: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.PROFILE.CREATE()
    commit('SET_USERS_LOADING')
    sendPostRequest(
      url, data, (data, url) => {
        commit('SET_USERS_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_USERS_LOADING_END')
        catcher(data, url)
      }
    )
  },
  forgetPass: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.PROFILE.FORGET_PASSWORD()
    commit('SET_USERS_LOADING')
    sendPostRequest(
      url, data, (data, url) => {
        commit('SET_USERS_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_USERS_LOADING_END')
        catcher(data, url)
      }
    )
  },
  changeEmail: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.PROFILE.CHANGE_EMAIL()
    commit('SET_USERS_LOADING')
    sendPostRequest(
      url, data, (data, url) => {
        commit('SET_USERS_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_USERS_LOADING_END')
        catcher(data, url)
      }
    )
  },
  changePass: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.PROFILE.CHANGE_PASSWORD()
    commit('SET_USERS_LOADING')
    sendPostRequest(
      url, data, (data, url) => {
        commit('SET_USERS_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_USERS_LOADING_END')
        catcher(data, url)
      }
    )
  },
  changeForgetPass: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.PROFILE.CHANGE_FORGET_PASSWORD()
    commit('SET_USERS_LOADING')
    sendPostRequest(
      url, data, (data, url) => {
        commit('SET_USERS_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_USERS_LOADING_END')
        catcher(data, url)
      }
    )
  },
  approveEmail: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.PROFILE.EMAIL_APPROVE()
    commit('SET_USERS_LOADING')
    sendPostRequest(
      url, data, (data, url) => {
        commit('SET_USERS_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_USERS_LOADING_END')
        catcher(data, url)
      }
    )
  },
  resendApproveEmail: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.PROFILE.EMAIL_RESEND_APPROVE()
    commit('SET_USERS_LOADING')
    sendPostRequest(
      url, data, (data, url) => {
        commit('SET_USERS_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_USERS_LOADING_END')
        catcher(data, url)
      }
    )
  },
  // loadUsersDetail: ({commit}, {url, id, finalizer=()=>{}, catcher=()=>{}}) => {
  //   if (!url) url = url = mendeleev.USER.USERS.USERS.DETAIL(id)
  //   sendGetRequest(
  //     url, (data, url) => {
  //       commit('SET_USERS_DETAIL', data);
  //       finalizer(data, url);
  //     }, (data, url) => {
  //       commit('SAVE_USERS_ERROR', data);
  //       catcher(data, url);
  //     }
  //   )
  // },
}

const mutations = {
  SET_USERS: (state, value) => {
    state.users.items = value
  },
  SET_USER_INFO: (state, value) => {
    state.users.info = value
  },
  SET_USERS_DETAIL: (state, value) => {
    state.users.detail = value
  },
  SET_USERS_COUNT: (state, value) => {
    state.users.count = value
  },
  SET_USERS_CURRENT_URL: (state, value) => {
    state.users.currentUrl = value
  },
  SET_USERS_NEXT_URL: (state, value) => {
    state.users.next = value
  },
  SET_USERS_PREV_URL: (state, value) => {
    state.users.prev = value
  },
  SET_USERS_LOADING: (state) => {
    state.users.loading = true
  },
  SET_USERS_LOADING_END: (state) => {
    state.users.loading = false
  },
  SAVE_USERS_ERROR: (state, error) => {
    state.users.error = error
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
